module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Devices/Printer-172731818acf585f342a91ce1bdef1df.svg";